import React from 'react';

import { Box } from '@wds/box';
import { useExperiment } from '@sm/webassets';
import { Package } from '~pricing/components/Summary';

import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import SummaryFooter from '~pricing/components/PricingFooter';
import { Packages } from '~shared/constants/pricing';
import useSummaryStyles from './useStyles';
import { usePricingState } from '~shared/hooks/usePricingState';
import useTreatment from '~pricing/hooks/useTreatment';
import { PricingPackage } from '~shared/types/pricing/pricingsvc';
import DiscountBanner from '../../components/DiscountBanner';

export default function PricingSummaryPage(): JSX.Element {
  const { PackagesContainer, Summary } = useSummaryStyles();
  const {
    state: {
      packages: { comparePlans, discountInfo, displayPackages, allPackages },
    },
  } = usePricingState();

  const {
    uiExperiment: {
      GROW_2427_TREATMENT,
      GROW_2629_FORMS_V2_TREATMENT,
      GROW_2529_FORMS_TREATMENT1,
      GROW_2529_FORMS_TREATMENT2,
    },
  } = useTreatment();

  const filteredPackages = displayPackages?.filter(pkg => pkg?.packageName !== Packages.Basic);

  const GROW_2529_TREATMENT = GROW_2629_FORMS_V2_TREATMENT || GROW_2529_FORMS_TREATMENT1 || GROW_2529_FORMS_TREATMENT2;

  function getPackage(pricingPackage: PricingPackage, index: number): JSX.Element {
    const props = {
      ...pricingPackage,
      comparisonSkuCost: pricingPackage.comparisonSkuCost || [],
      comparePlans,
      discountInfo,
      key: `package-${pricingPackage.packageName}`,
      isLastPackage: index + 1 === filteredPackages.length,
    };

    if (GROW_2529_TREATMENT) {
      return <GROW_2529_TREATMENT.Package {...props} />;
    }

    return <Package {...props} />;
  }

  const { treatments: discountBannerTreatments } = useExperiment({
    name: 'billing_20014_teams_discount',
    treatmentNames: ['billing_20014_teams_discount_control', 'billing_20014_teams_discount_treatment'],
  });

  const showDiscountBanner = discountBannerTreatments?.billing_20014_teams_discount_treatment?.treatmentName;

  return (
    <div key="PricingSummary">
      {showDiscountBanner && <DiscountBanner />}
      <header>
        {GROW_2427_TREATMENT && <GROW_2427_TREATMENT.SocialProof />}
        <MainHeading />
        <Navigation />
      </header>
      <Box className={Summary}>
        <Box className={PackagesContainer}>
          {filteredPackages?.map(
            (pricingPackage, index: number) => pricingPackage && getPackage(pricingPackage, index)
          )}
        </Box>
        <SummaryFooter packages={allPackages} />
      </Box>
    </div>
  );
}
